/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Description2Inputs */

const en_coinvestments_editemail_description2 = /** @type {(inputs: Coinvestments_Editemail_Description2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recipients will receive the following email inviting them to the opportunity.`)
};

/**
* | output |
* | --- |
* | "Recipients will receive the following email inviting them to the opportunity." |
*
* @param {Coinvestments_Editemail_Description2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_description2 = /** @type {((inputs?: Coinvestments_Editemail_Description2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Description2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_description2(inputs)
});
export { coinvestments_editemail_description2 as "coInvestments_editEmail_description" }